import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app-entry/app.component';
import { appConfig } from './app-entry/app.config';
import { WidgetsService } from './components/organisms/widgets-loader/widgets.service';

bootstrapApplication(AppComponent, appConfig)
    .then((appRef) => {
        if (typeof window !== 'undefined') {
            const widgetsService = appRef.injector.get(WidgetsService);
            widgetsService.waitForWidgets().then(() => {
                (window as any).APP_IS_LOADED = true;
                performance.mark('APP_IS_LOADED');
            });
        }
    })
    .catch((err) => console.error(err));
